import * as React from "react";
import useContentfulBlogPosts from '../contentfulBlogPosts';
import { Link } from 'gatsby';

function RecentBlogPosts() {
    const posts = useContentfulBlogPosts();
    const latestPosts = posts.slice(0, 4); // Select the 4 latest posts

    return (
        <section className="RecentBlogPosts bg-white">
            <div className="grid grid-cols-12">
                <div className="col-span-12 lg:col-start-2 lg:col-span-10">
                    <h2 className="text-center font-semibold">Recent Blog Posts</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-10 mb-8 pt-10">
                        {latestPosts.map((post, index) => {
                            let imageUrl = 'defaultImageUrl'; // default image URL
                            if (post.fields && post.fields.postFeaturedImage && post.fields.postFeaturedImage.fields && post.fields.postFeaturedImage.fields.file && post.fields.postFeaturedImage.fields.file.url) {
                                imageUrl = post.fields.postFeaturedImage.fields.file.url;
                            }
                            return (
                                <div key={index} className="flex flex-col">
                                    <div className="blog-posts-image-wrapper">
                                        <Link to={`/blog/${post.fields.slug}`}>
                                            <img
                                                src={imageUrl}
                                                alt={post.fields.postTitle}
                                                width="940"
                                                height="560"
                                                style={{ objectFit: 'cover' }}
                                                loading="lazy"
                                            />
                                        </Link>
                                    </div>
                                    <div className="blog-post-wrapper border-l-2 border-r-2 px-4 pt-4 flex-grow">
                                        <Link to={`/blog/${post.fields.slug}`}>
                                            <h4>{post.fields.postTitle}</h4>
                                        </Link>
                                        <p>{post.fields.postExcerpt}</p>
                                    </div>
                                    <div className="button-wrapper flex justify-between items-center border-l-2 border-r-2 border-b-2 p-4">
                                        <Link to={`/blog/${post.fields.slug}`}>
                                            <p className="pb-0 font-semibold">Read the full article</p>
                                        </Link>
                                        <span>{'\u2192'}</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default RecentBlogPosts;